import { render, staticRenderFns } from "./captain_cancellation_reasons.vue?vue&type=template&id=7989bf1b"
import script from "./captain_cancellation_reasons.vue?vue&type=script&lang=js"
export * from "./captain_cancellation_reasons.vue?vue&type=script&lang=js"
import style0 from "./captain_cancellation_reasons.vue?vue&type=style&index=0&id=7989bf1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports